import React from "react";
import PlanList from "@components/PlanAppBranch/PlanList";

import "./PlanApp.scss";

export default function PlanApp() {
  return <PlanList />;
}
